import "./Plans.scss";
import pathway from "../../../assets/images/pathway.png";
import assessment from "../../../assets/images/assessment.png";
import actions from "../../../assets/images/actions.png";
import planbigcircle from "../../../assets/images/planbigcircle.png";
import { useEffect, useRef } from "react";
import * as $ from "jquery";

const SCROLL_CONFIG = {
  mobile: {
    plantitle1: { min: 0.1, max: 0.4 },
    plantitle2: { min: 0.15, max: 0.45 },
    plantitle3: { min: 0.25, max: 0.5 },
    planbigcircle: { min: 0.2, max: 0.6 },
  },
  desktop: {
    plantitle1: { min: 0.1, max: 0.5 },
    plantitle2: { min: 0.15, max: 0.6 },
    plantitle3: { min: 0.25, max: 0.7 },
    planbigcircle: { min: 0.2, max: 0.6 },
  },
};

const Plans = () => {
  const plantitle1 = useRef();
  const plantitle1desktop = useRef();
  const plantitle2 = useRef();
  const plantitle2desktop = useRef();
  const plantitle3 = useRef();
  const plantitle3desktop = useRef();
  const planbigcircleitem = useRef();

  /* useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const documentHeight = document.body.scrollHeight;

      const config =
        window.innerWidth < 577 ? SCROLL_CONFIG.mobile : SCROLL_CONFIG.desktop;

      const scrollRange = (configItem) => ({
        min: configItem.min * documentHeight,
        max: configItem.max * documentHeight,
      });

      // const updateStyle = (element, condition, property, valueOn, valueOff) => {
      //   if (element) {
      //     element.style[property] = condition ? valueOn : valueOff;
      //   }
      // };
      const isMobile = window.innerWidth < 577;
      const updateStyle = (element, condition, property, valueOn, valueOff) => {
        if (element && element.style) {
          if (isMobile) {
            element.style[property] = "0%";
          } else {
            element.style[property] = condition ? valueOn : valueOff;
          }
        }
      };

      const ranges = {
        plantitle1: scrollRange(config.plantitle1),
        plantitle2: scrollRange(config.plantitle2),
        plantitle3: scrollRange(config.plantitle3),
        planbigcircle: scrollRange(config.planbigcircle),
      };

      // Update styles for plantitle1
      updateStyle(
        plantitle1.current,
        scrollPosition >= ranges.plantitle1.min &&
          scrollPosition <= ranges.plantitle1.max,
        "left",
        "0%",
        "100%"
      );
      updateStyle(
        plantitle1desktop.current,
        scrollPosition >= ranges.plantitle1.min &&
          scrollPosition <= ranges.plantitle1.max,
        "left",
        "0%",
        "100%"
      );

      // Update styles for plantitle2
      updateStyle(
        plantitle2.current,
        scrollPosition >= ranges.plantitle2.min &&
          scrollPosition <= ranges.plantitle2.max,
        "left",
        "0%",
        "100%"
      );
      updateStyle(
        plantitle2desktop.current,
        scrollPosition >= ranges.plantitle2.min &&
          scrollPosition <= ranges.plantitle2.max,
        "left",
        "0%",
        "100%"
      );

      // Update styles for plantitle3
      updateStyle(
        plantitle3.current,
        scrollPosition >= ranges.plantitle3.min &&
          scrollPosition <= ranges.plantitle3.max,
        "left",
        "0%",
        "100%"
      );
      updateStyle(
        plantitle3desktop.current,
        scrollPosition >= ranges.plantitle3.min &&
          scrollPosition <= ranges.plantitle3.max,
        "left",
        "0%",
        "100%"
      );

      // Update styles for planbigcircle
      updateStyle(
        planbigcircleitem.current,
        scrollPosition >= ranges.planbigcircle.min &&
          scrollPosition <= ranges.planbigcircle.max,
        "transform",
        "scale(1)",
        "scale(0)"
      );
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); */

  return (
    <section className="plans">
      <div className="container">
        <div className="title">
          What Lagos <span>aspires to with this plan</span>
        </div>
        <div className="plans-section">
          <div className="custom-row plan-section-row">
            <div className="custom-col plan-section-left">
              <div className="plan-title plan-section-left-title">
                <div className="custom-row mobile">
                  <img src={pathway} alt="pathway" className="mobile" />
                  <div ref={plantitle1} className="title mobile">
                    Pathway
                  </div>
                </div>
                <div className="plan-description mobile">
                  Put Lagos on the <b>pathway to build resilience</b> to climate
                  change impacts
                </div>
                <div className="custom-row desktop plan-row">
                  <div className="first-div desktop">
                    <img src={pathway} alt="pathway" className="desktop" />
                  </div>
                  <div className="custom-col desktop">
                    <div ref={plantitle1desktop} className="title desktop">
                      Pathway
                    </div>
                    <div className="plan-description desktop">
                      Put Lagos on the <b>pathway to build resilience</b> to
                      climate change impacts
                    </div>
                  </div>
                </div>
              </div>
              <div className="plan-title plan-section-left-title">
                <div className="custom-row mobile">
                  <img src={assessment} alt="assessment" className="mobile" />
                  <div ref={plantitle2} className="title mobile">
                    Data Driven Impact
                  </div>
                </div>
                <div className="plan-description mobile">
                  Equip decision makers with a <b>data-driven assessment</b> of
                  the cost of climate inaction and{" "}
                  <b>prioritize solutions based on socioeconomic ROI</b>
                </div>
                <div className="custom-row desktop plan-row">
                  <div className="first-div desktop">
                    <img
                      src={assessment}
                      alt="assessment"
                      className="desktop"
                    />
                  </div>
                  <div className="custom-col desktop">
                    <div ref={plantitle2desktop} className="title desktop">
                      Data Driven Impact
                    </div>
                    <div className="plan-description desktop">
                      Equip decision makers with a <b>data-driven assessment</b>{" "}
                      of the cost of climate inaction and{" "}
                      <b>prioritize solutions based on socioeconomic ROI</b>
                    </div>
                  </div>
                </div>
              </div>
              <div className="plan-title plan-section-left-title">
                <div className="custom-row mobile">
                  <img src={actions} alt="actions" className="mobile" />
                  <div ref={plantitle3} className="title mobile">
                    Mobilize Funding
                  </div>
                </div>
                <div className="plan-description mobile">
                  <b>Mobilize action and funding</b> from both public and
                  private sector actors
                </div>
                <div className="custom-row desktop plan-row">
                  <div className="first-div desktop">
                    <img src={actions} alt="actions" className="desktop" />
                  </div>
                  <div className="custom-col desktop">
                    <div ref={plantitle3desktop} className="title desktop">
                      Mobilize Funding
                    </div>
                    <div className="plan-description desktop">
                      <b>Mobilize action and funding</b> from both public and
                      private sector actors
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="desktop">
              <img
                src={planbigcircle}
                alt="plans"
                className="planbigcircle desktop"
                ref={planbigcircleitem}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Plans;
